import videoParser from 'js-video-url-parser';

/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */

const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

const localhostDomainRE = /^localhost[:?\d]*(?:[^:?\d]\S*)?$/;
const nonLocalhostDomainRE = /^[^\s.]+\.\S{2,}$/;

/**
 * Loosely validate a URL `string`.
 */
export const isUrl = (string) => {
  if (typeof string !== 'string') {
    return false;
  }

  const match = string.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }

  const everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }

  try {
    // eslint-disable-next-line no-new
    new URL(string);
  } catch (err) {
    return false;
  }

  return (
    localhostDomainRE.test(everythingAfterProtocol) ||
    nonLocalhostDomainRE.test(everythingAfterProtocol)
  );
};

const YOUTUBE_PREFIX = 'https://www.youtube.com/embed/';
const VIMEO_PREFIX = 'https://player.vimeo.com/video/';
// const DAILYMOTION_PREFIX = 'https://www.dailymotion.com/embed/video/';
// const YOUKU_PREFIX = 'https://player.youku.com/embed/';
// const COUB_PREFIX = 'https://coub.com/embed/';

export const parseVideoUrl = (url) => {
  if (!isUrl(url)) return;

  const videoData = videoParser.parse(url);

  if (videoData?.provider && videoData.id) {
    const { id, provider } = videoData;

    const providerUrls = {
      youtube: `${YOUTUBE_PREFIX}${id}`,
      vimeo: `${VIMEO_PREFIX}${id}`,
      // dailymotion: `${DAILYMOTION_PREFIX}${id}`,
      // youku: `${YOUKU_PREFIX}${id}`,
      // coub: `${COUB_PREFIX}${id}`,
    };

    return {
      id,
      provider,
      url: providerUrls[provider],
    };
  }

  // Matches youtube shorts. Need to manually do this because videoParser does not handle this case.
  const match = url.match(/youtube.com\/shorts\/([\w-]{11})/i);
  if (match && match.length > 1) {
    return {
      id: match[1],
      provider: 'youtubeShorts',
      url: `${YOUTUBE_PREFIX}${match[1]}`,
    };
  }
};
